/**
 * Subdomain and Route Protection utilities for Gastro Bloggers Day CRM
 */

export function isPartnersSubdomainHost(hostname = '') {
  const h = (hostname || '').trim().toLowerCase();
  return (
    h === 'partners.gastrobloggersday.com' ||
    h.endsWith('.partners.gastrobloggersday.com') ||
    h === 'partners.localhost' ||
    h.endsWith('.partners.localhost')
  );
}

export function isLocalDevHost(hostname = '') {
  const h = (hostname || '').trim().toLowerCase();
  return h === 'localhost' || h === '127.0.0.1' || h.endsWith('.localhost');
}

export function isCrmAllowedHost(hostname = '') {
  return isPartnersSubdomainHost(hostname) || isLocalDevHost(hostname);
}

export function shouldRedirectCrmPath(hostname = '', pathname = '') {
  if (isCrmAllowedHost(hostname)) return false;
  const p = (pathname || '').toLowerCase();
  return (
    p === '/partners' ||
    p.startsWith('/partners/') ||
    p === '/crm' ||
    p.startsWith('/crm/')
  );
}
